import React, { ReactNode } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import NavBar from '../NavBar';
import { PatientInfoVisibility } from '../../types/PatientInfoVisibility';
// import classNames from 'classnames';
// import IconButton from '../IconButton';
// import Dropdown from '../Dropdown';
// import HeaderPatientInfo from '../HeaderPatientInfo';
// import { Icons } from '@ohif/ui-next';
function Header({
  children,
  menuOptions,
  isReturnEnabled = true,
  onClickReturnButton,
  isSticky = false,
  WhiteLabeling,
  showPatientInfo = PatientInfoVisibility.VISIBLE_COLLAPSED,
  servicesManager,
  Secondary,
  appConfig,
  ...props
}: withAppTypes): ReactNode {
  const { t } = useTranslation('Header');

  // TODO: this should be passed in as a prop instead and the react-router-dom
  // dependency should be dropped
  // const onClickReturn = () => {
  //   if (isReturnEnabled && onClickReturnButton) {
  //     onClickReturnButton();
  //   }
  // };

  const topMargin = window.innerWidth < 768 ? '0px' : '15px';

  return (
    <NavBar
      isSticky={isSticky}
      {...props}
    >
      <div
        className="relative items-center"
        style={{ marginTop: topMargin }}
      >
        <div className="absolute left-0 flex -translate-y-1/2 items-center">
          {/* <div
            className={classNames(
              'mr-3 inline-flex items-center',
              isReturnEnabled && 'cursor-pointer'
            )}
            onClick={onClickReturn}
            data-cy="return-to-work-list"
          >
            {isReturnEnabled && <Icons.ChevronClosed className="text-primary-active w-8" />}
            <div className="ml-1">
              {WhiteLabeling?.createLogoComponentFn?.(React, props) || <Icons.OHIFLogo />}
            </div>
          </div> */}
        </div>
        <div className="absolute left-[250px] h-8 -translate-y-1/2">{Secondary}</div>
        <div className="absolute transform">
          <div className="flex flex-col items-center justify-center">{children}</div>
        </div>
        {/* <div className="absolute right-0 top-1/2 flex -translate-y-1/2 select-none flex-col items-center">
          {showPatientInfo !== PatientInfoVisibility.DISABLED && (
            <HeaderPatientInfo
              servicesManager={servicesManager}
              appConfig={appConfig}
            />
          )}
          <div className="border-primary-dark mx-1.5 h-[25px] border-r"></div>
          <div className="flex-shrink-0">
            <Dropdown
              id="options"
              showDropdownIcon={false}
              list={menuOptions}
              alignment="right"
            >
              <IconButton
                id={'options-settings-icon'}
                variant="text"
                color="inherit"
                size="initial"
                className="text-primary-active hover:bg-primary-dark h-full w-full"
              >
                <Icons.ByName name="icon-settings" />
              </IconButton>
            </Dropdown>
          </div>
        </div> */}
      </div>
    </NavBar>
  );
}

Header.propTypes = {
  menuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      onClick: PropTypes.func.isRequired,
    })
  ),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  isReturnEnabled: PropTypes.bool,
  isSticky: PropTypes.bool,
  onClickReturnButton: PropTypes.func,
  WhiteLabeling: PropTypes.object,
  showPatientInfo: PropTypes.string,
  servicesManager: PropTypes.object,
};

export default Header;
